import { render, staticRenderFns } from "./kioskUpdates.vue?vue&type=template&id=52c843a8"
import script from "./kioskUpdates.vue?vue&type=script&lang=js"
export * from "./kioskUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports